import { z } from 'zod';
import {
  ContactSubFormSchema,
  NonStandardToolsFieldSchema,
  OptionLabelValueSchema,
} from '../../utils/schemas';
import { TicketDetailForms } from '../DefinedFormTypes';

export const SmartHandsFormSchema = z.object({
  formType: z.literal(TicketDetailForms.enum.SmartHands),
  installOrTroubleShootingLV: OptionLabelValueSchema,
  installOrTroubleShootingGuideLV: OptionLabelValueSchema,
  whichEquipment: z.string().trim().nonempty('Required'),
  portMapping: z.string(),
  techToTestWith: z.discriminatedUnion('techToTestWith', [
    z.object({ techToTestWith: z.literal('CustomerIT') }),

    z.object({ techToTestWith: z.literal('Person') }),
    z.object({ techToTestWith: z.literal('No') }),
  ]),
  itTestingContacts: z.array(ContactSubFormSchema),
  nonStandardTools: NonStandardToolsFieldSchema,
});

export type SmartHandsForm = z.infer<typeof SmartHandsFormSchema>;
